import React from 'react';
import { Link } from 'react-router-dom';
import { isProActive } from '../billing';
import PageMeta from '../PageMeta';
import { AccountCard } from './History';

/* Dedicated sign-in page so Pro subscribers on a new device can sign in
   BEFORE uploading — otherwise they hit the paywall after the analysis and
   have to sign in and re-analyse. */
export default function SignIn({ plan, onCancelPlan, onSignIn, onSignOut }) {
  const proActive = isProActive(plan);
  return (
    <main className="history-page signin-page">
      <PageMeta title="Sign in — Prop Doc" path="/signin" noindex />
      <section className="history-head">
        <div>
          <h1>{proActive ? 'Your account' : 'Sign in'}</h1>
          <p>
            {proActive
              ? 'Pro is active on this device — your reports unlock automatically.'
              : 'Already have Prop Doc Pro? Sign in before you analyse so your reports unlock instantly on this device — no paywall, no re-analysing.'}
          </p>
        </div>
      </section>

      <AccountCard
        plan={plan}
        onCancelPlan={onCancelPlan}
        onSignIn={onSignIn}
        onSignOut={onSignOut}
      />

      <p className="signin-note">
        {proActive ? (
          <>Ready to go — <Link to="/analyze">analyse a document</Link>.</>
        ) : (
          <>Don&rsquo;t have Pro yet? Single reports are $2.99 with no account needed — <Link to="/pricing">see pricing</Link>.</>
        )}
      </p>
    </main>
  );
}
